const LOGIN_BOX_ID = "login_box"
const TRIGGER_CLASSNAME = "js-login-trigger"
const ERROR_CLASSNAME = "js-login-error"
// const SUBMIT_CLASSNAME = 'js-login-submit';

function formSubmitListener({ errorEl }) {
  return async function listener(event) {
    event.preventDefault()

    try {
      errorEl.textContent = "" // eslint-disable-line no-param-reassign
      errorEl.style.display = "none" // eslint-disable-line no-param-reassign

      const form = event.target
      const url = form.action
      const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new FormData(form),
      })

      if (response.status === 429) {
        errorEl.textContent = "Too many login attempts. Please try again later." // eslint-disable-line no-param-reassign
        errorEl.style.display = "block" // eslint-disable-line no-param-reassign
        return
      }

      const result = await response.json()

      if (result.success) {
        const redirectUrl = new URL(result.redirect, window.location.origin) // eslint-disable-line compat/compat
        if (redirectUrl.origin === window.location.origin) {
          window.location.href = redirectUrl.href
        } else {
          throw new Error("Invalid redirect URL")
        }
      } else {
        const [firstError] = result.errors
        errorEl.textContent = firstError // eslint-disable-line no-param-reassign
        errorEl.style.display = "block" // eslint-disable-line no-param-reassign
      }
    } catch (err) {
      // console.error(err);
      errorEl.textContent = "An error occurred. Please try again." // eslint-disable-line no-param-reassign
      errorEl.style.display = "block" // eslint-disable-line no-param-reassign
    }
  }
}

function init() {
  const loginBox = document.getElementById(LOGIN_BOX_ID)
  if (!loginBox) return

  // Get the first error element (since getElementsByClassName returns a collection)
  const errorEl = loginBox.querySelector(`.${ERROR_CLASSNAME}`)
  const form = loginBox.querySelector("form")

  if (form && errorEl) {
    form.addEventListener("submit", formSubmitListener({ errorEl }))
    errorEl.style.display = "none"
  }
  const buttons = document.querySelectorAll(`.${TRIGGER_CLASSNAME}`)
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()
    })
  })
}

export default init
